import { TransactionTagType } from "@syla/shared/types/models/TransactionBase";
import React from "react";
import { useGetWalletOptions } from "../../../../../hooks/wallet/useGetWalletOptions";
import { useCurrentAccountStore } from "../../../../../store/currentAccountStore";
import { Selector, SelectorProps } from "../../../../selector/Selector";

type DataSourceFilterType = {
  values: string[];
  onChange: (value: string[]) => void;
} & Omit<
  SelectorProps<TransactionTagType>,
  "onChange" | "options" | "values" | "isLoading" | "placeholder"
>;

export function DataSourceFilter({
  values,
  onChange,
  ...props
}: DataSourceFilterType): React.ReactElement {
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);

  const walletOptions = useGetWalletOptions(accountId);

  return (
    <Selector
      values={values}
      onChange={onChange}
      options={walletOptions.data ?? []}
      isLoading={walletOptions.data === undefined}
      placeholder="Data Source"
      enableSearch
      enableBulkSelect
      enableDeselect
      enableMultiSelect
      moveSelectedToTop
      {...props}
    />
  );
}
